import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
import { FadeUp } from "./FadeUp";
export function FaqAccordion() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="scroll-mt-20 py-20 md:py-28" aria-labelledby="faq-heading" data-id="element-68" data-mp="39rwwpatnz3lr">
      <div className="mx-auto w-full max-w-[880px] px-5 md:px-12" data-id="element-69" data-mp="3njl81bw39o1o">
        <FadeUp data-id="element-70" data-mp="3nlxx0909kyo8">
          <h2 id="faq-heading" className="text-center font-serif text-[36px] leading-none tracking-[-0.02em] text-white sm:text-[clamp(40px,4.2vw,56px)]" data-id="element-71" data-mp="3iks347uvb5d4">
            Questions, answered
          </h2>
        </FadeUp>
        <FadeUp className="mt-10" data-id="element-72" data-mp="3sienh9uxrp4h">
          <ul className="flex flex-col gap-[2px]" data-id="element-73" data-mp="3sjhc1b4sdfh8">
            {faqs.map((item, i) => {
            const isOpen = open === i;
            return <li key={item.q} className="bg-card" data-id="element-74" data-mp="1y56pxafkszf5" data-mpi={i}>
                  <h3 data-id="element-75" data-mp="1y6rg6nuuxw77">
                    <button type="button" id={`faq-q-${i}`} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-150 hover:bg-white/[0.04] md:px-8" data-id="element-76" data-mp="1y79jg4fxtaom">
                      <span className="font-serif text-[19px] leading-tight text-white md:text-[21px]" data-id="element-77" data-mp="3v5ll9qyf0f21">{item.q}</span>
                      <PlusIcon className={`h-6 w-6 shrink-0 text-white transition-transform duration-200 ease-out md:h-7 md:w-7 ${isOpen ? "rotate-45" : ""}`} strokeWidth={1.5} aria-hidden="true" data-id="element-78" data-mp="3yiwt79yomvi" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-79" data-mp="2ervf8enqjgpr">
                    {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: "auto",
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden border-t border-ink" data-id="element-80" data-mp="3i316iekyx40x">
                        <p className="max-w-[60ch] px-6 pb-6 pt-5 text-[14px] leading-relaxed text-body md:px-8 md:text-[15px]" data-id="element-81" data-mp="3w3lppbusp1uy">{item.a}</p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </FadeUp>
      </div>
    </section>;
}